import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Mail, Shield, TrendingUp } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary-900 text-white">
      <div className="container-news py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="font-playfair text-2xl font-bold mb-4">
              UNBIASED NEWS
            </h3>
            <p className="text-primary-300 mb-4 leading-relaxed">
              Delivering structural impact news with zero noise. Every article is 
              AI-curated for global relevance and analyzed for bias to ensure you 
              receive only the most significant developments affecting our world.
            </p>
            <div className="flex items-center space-x-4 text-sm">
              <span className="flex items-center">
                <Globe className="h-4 w-4 mr-1" />
                Global Coverage
              </span>
              <span className="flex items-center">
                <Shield className="h-4 w-4 mr-1" />
                Bias-Analyzed
              </span>
              <span className="flex items-center">
                <TrendingUp className="h-4 w-4 mr-1" />
                Impact-Scored
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-4">Navigate</h4>
            <ul className="space-y-2 text-primary-300">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Latest News
                </Link>
              </li>
              <li>
                <Link to="/category/Geopolitics" className="hover:text-white transition-colors">
                  Geopolitics
                </Link>
              </li>
              <li>
                <Link to="/category/Economy" className="hover:text-white transition-colors">
                  Global Economy
                </Link>
              </li>
              <li>
                <Link to="/category/Climate" className="hover:text-white transition-colors">
                  Environment
                </Link>
              </li>
              <li>
                <Link to="/category/Technology" className="hover:text-white transition-colors">
                  Technology
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Impact */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-4">Impact</h4>
            <ul className="space-y-2 text-primary-300">
              <li>
                <span className="hover:text-white transition-colors cursor-pointer">
                  How We Score Impact
                </span>
              </li>
              <li>
                <span className="hover:text-white transition-colors cursor-pointer">
                  Bias Detection Method
                </span>
              </li>
              <li>
                <span className="hover:text-white transition-colors cursor-pointer">
                  ETHIX Staking Program
                </span>
              </li>
              <li>
                <span className="hover:text-white transition-colors cursor-pointer">
                  Sustainable Impact
                </span>
              </li>
            </ul>
            
            <div className="mt-6">
              <a 
                href="mailto:news@unbiasednews.xyz"
                className="flex items-center text-accent-400 hover:text-accent-300 transition-colors"
              >
                <Mail className="h-4 w-4 mr-2" />
                news@unbiasednews.xyz
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-primary-400">
            <div className="mb-4 md:mb-0">
              © 2026 Unbiased News. Structural impact, zero noise.
            </div>
            <div className="flex items-center space-x-6">
              <span>Privacy Policy</span>
              <span>Terms of Service</span>
              <span>Editorial Standards</span>
            </div>
          </div>
        </div>
      </div>

      {/* Impact Stats Bar */}
      <div className="bg-primary-950 border-t border-primary-800">
        <div className="container-news py-4">
          <div className="flex items-center justify-center space-x-8 text-sm text-primary-400">
            <div className="text-center">
              <div className="text-white font-bold text-lg">2,847</div>
              <div>Articles Analyzed</div>
            </div>
            <div className="text-center">
              <div className="text-white font-bold text-lg">15.2K</div>
              <div>ETHIX Staked for Impact</div>
            </div>
            <div className="text-center">
              <div className="text-white font-bold text-lg">97%</div>
              <div>Bias Accuracy Rate</div>
            </div>
            <div className="text-center">
              <div className="text-white font-bold text-lg">Global</div>
              <div>Coverage Reach</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;